import i18nFactory from '@yandex-int/i18n';
import { Button } from 'lego-on-react';
import * as React from 'react';

import { Bem } from '../../../service/Bem/Bem';
import { formatNumber } from '../../../service/FormatHelpers/FormatHelpers';
import { pluralizeWord } from '../../../service/Pluralize/Pluralize';
import { RecommendationCharacter, RecommendationType } from '../../../typings/recommendations';
import { Shape2Icon } from '../../Shape2/Shape2';
import { RecommendationCard, RecommendationCardView } from '../RecommendationCard';

import './BannerModerationRecommendationCard.css';
import * as keyset from './BannerModerationRecommendationCard.i18n';

const i18n = i18nFactory(keyset);

interface RecommendationsPopupViewProps {
    character: RecommendationCharacter;
    icon: Shape2Icon;
    view: RecommendationCardView.recommendationsPopup;
    onShow?: (view: RecommendationCardView, type: RecommendationType) => void;
}

interface NormalViewProps {
    character: RecommendationCharacter;
    icon: Shape2Icon;
    view: RecommendationCardView.normal;
    bannersNumber: number;
    bannersPageUrl: string;
    onShow?: (view: RecommendationCardView, type: RecommendationType) => void;
}

export type BannerModerationRecommendationCardProps = RecommendationsPopupViewProps | NormalViewProps;

export class BannerModerationRecommendationCard extends React.Component<BannerModerationRecommendationCardProps> {
    render() {
        const { view, character, icon, onShow } = this.props;

        return (
            <RecommendationCard
                type={RecommendationType.changeBannerForModeration}
                icon={icon}
                character={character}
                title={this.getTitle()}
                titleHint={this.getTitleHint()}
                view={view}
                isInProgress={false}
                buttons={this.getButtons()}
                onShow={onShow}
            >
                {this.getBody()}
            </RecommendationCard>
        );
    }

    private getTitleHint = (): string => {
        const { view } = this.props;

        switch (view) {
            case RecommendationCardView.normal:
                return i18n('several-banner-title-hint');

            case RecommendationCardView.recommendationsPopup:
                return i18n('one-banner-title-hint');

            default:
                throw Error(`Не определена подпись для заголовка рекомендации вида ${view}`);
        }
    };

    private getTitle = (): string => {
        if (this.props.view === RecommendationCardView.recommendationsPopup) {
            return i18n('simple-title');
        }

        const itemsLength = this.props.bannersNumber;
        const formattedItemsLength = formatNumber(itemsLength);

        if (itemsLength === 1) {
            return i18n('one-banner-title', {
                count: formattedItemsLength
            });
        }

        return pluralizeWord(
            [
                i18n('twenty-one-banner-title', {
                    count: formattedItemsLength
                }),
                i18n('some-banner-title', {
                    count: formattedItemsLength
                }),
                i18n('many-banner-title', {
                    count: formattedItemsLength
                })
            ],
            itemsLength
        );
    };

    private getBody = () => {
        if (this.props.view === RecommendationCardView.recommendationsPopup) {
            return (
                <>
                    <p className={Bem.cls('banner-moderation-recommendaiton-card', 'body-text')}>
                        {i18n('popup-ad-decline-req')}
                    </p>
                    <p className={Bem.cls('banner-moderation-recommendaiton-card', 'body-text')}>
                        {i18n('how-to-fix')}
                    </p>
                </>
            );
        }

        return (
            <>
                <p className={Bem.cls('banner-moderation-recommendaiton-card', 'body-text')}>
                    {i18n('ad-decline-req')}
                </p>
                <p className={Bem.cls('banner-moderation-recommendaiton-card', 'body-text')}>{i18n('open-ad-list')}</p>
            </>
        );
    };

    private getButtons = () => {
        if (this.props.view === RecommendationCardView.recommendationsPopup) {
            return undefined;
        }

        const { bannersNumber, bannersPageUrl } = this.props;
        const formattedItemsLength = formatNumber(bannersNumber);

        const buttonText = pluralizeWord(
            [
                i18n('show-one-banner-button', {
                    count: formattedItemsLength
                }),
                i18n('show-some-banner-button', {
                    count: formattedItemsLength
                }),
                i18n('show-many-banner-button', {
                    count: formattedItemsLength
                })
            ],
            bannersNumber
        );

        return [<Button key={1} theme={'action'} size={'n'} text={buttonText} type={'link'} url={bannersPageUrl} />];
    };
}
